// 反向构建富文本的内容
export const reverseConstructRichArea = (mailContent, insertArguments) => {
  Object.values(insertArguments).forEach((item) => {
    const matchInsert = Object.keys(insertArguments).find((key) => insertArguments[key] === item);
    mailContent = mailContent.replaceAll(
      item,
      `<span class="insert-argument" contenteditable="false">${matchInsert}</span>`
    );
  });

  return mailContent;
};


export const a = {a: 1}